// Шаблони повідомлень клієнту (SMS/email) 3 мовами. Майстер обирає шаблон+мову,
// текст підставляється з даних запису й лишається редагованим у модалці.
// Плейсхолдери: name, date, time, code (код дверей), findUsUrl, bookUrl.

const LANDING_URL = (process.env.REACT_APP_LANDING_URL || "https://cleanhands.club").replace(/\/$/, "");
export const findUsUrl = `${LANDING_URL}/#find-us`;
export const bookUrl = LANDING_URL;

export const MESSAGE_LANGS = ["pl", "uk", "en"];

// Порядок = порядок у випадайці. needsCode → показати поле «код дверей».
export const MESSAGE_TEMPLATES = [
  { key: "reminder", needsCode: false },
  { key: "entrance", needsCode: true },
  { key: "reminderEntrance", needsCode: true },
  { key: "thanks", needsCode: false },
  { key: "custom", needsCode: false },
];

const hi = { pl: "Cześć", uk: "Вітаємо", en: "Hi" };

const T = {
  reminder: {
    subject: { pl: "Przypomnienie o wizycie — Clean Hands Club", uk: "Нагадування про запис — Clean Hands Club", en: "Appointment reminder — Clean Hands Club" },
    body: {
      pl: (c) => `${hi.pl}${c.name ? " " + c.name : ""}! Przypominamy o wizycie w Clean Hands Club: ${c.date} o ${c.time}. Do zobaczenia!`,
      uk: (c) => `${hi.uk}${c.name ? ", " + c.name : ""}! Нагадуємо про ваш запис у Clean Hands Club: ${c.date} о ${c.time}. Чекаємо на вас!`,
      en: (c) => `${hi.en}${c.name ? " " + c.name : ""}! A reminder about your appointment at Clean Hands Club: ${c.date} at ${c.time}. See you!`,
    },
  },
  entrance: {
    subject: { pl: "Jak nas znaleźć — Clean Hands Club", uk: "Як нас знайти — Clean Hands Club", en: "How to find us — Clean Hands Club" },
    body: {
      pl: (c) => `Clean Hands Club — jak trafić: wjazd na podwórko od ul. Ludwika Solskiego, wejście z dziedzińca, 2. piętro, lokal D. Kod do drzwi: ${c.code}. Zdjęcia dojazdu: ${c.findUsUrl}`,
      uk: (c) => `Clean Hands Club — як знайти: заїзд у дворик з вул. Ludwika Solskiego, вхід із дворика, 2-й поверх, приміщення D. Код до дверей: ${c.code}. Фото маршруту: ${c.findUsUrl}`,
      en: (c) => `Clean Hands Club — how to find us: drive into the courtyard from Ludwika Solskiego St., entrance from the courtyard, 2nd floor, unit D. Door code: ${c.code}. Route photos: ${c.findUsUrl}`,
    },
  },
  reminderEntrance: {
    subject: { pl: "Przypomnienie i dojazd — Clean Hands Club", uk: "Нагадування та як знайти — Clean Hands Club", en: "Reminder & directions — Clean Hands Club" },
    body: {
      pl: (c) => `${hi.pl}${c.name ? " " + c.name : ""}! Przypominamy o wizycie ${c.date} o ${c.time}. Wjazd na podwórko od ul. Ludwika Solskiego, 2. piętro, lokal D. Kod do drzwi: ${c.code}. Jak trafić: ${c.findUsUrl}`,
      uk: (c) => `${hi.uk}${c.name ? ", " + c.name : ""}! Нагадуємо про запис ${c.date} о ${c.time}. Заїзд у дворик з вул. Ludwika Solskiego, 2-й поверх, приміщення D. Код до дверей: ${c.code}. Як знайти: ${c.findUsUrl}`,
      en: (c) => `${hi.en}${c.name ? " " + c.name : ""}! A reminder about your visit on ${c.date} at ${c.time}. Courtyard entrance from Ludwika Solskiego St., 2nd floor, unit D. Door code: ${c.code}. Directions: ${c.findUsUrl}`,
    },
  },
  thanks: {
    subject: { pl: "Dziękujemy za wizytę — Clean Hands Club", uk: "Дякуємо за візит — Clean Hands Club", en: "Thank you for your visit — Clean Hands Club" },
    body: {
      pl: (c) => `Dziękujemy za wizytę w Clean Hands Club${c.name ? ", " + c.name : ""}! Zapraszamy ponownie: ${c.bookUrl}`,
      uk: (c) => `Дякуємо за візит у Clean Hands Club${c.name ? ", " + c.name : ""}! Запрошуємо знову: ${c.bookUrl}`,
      en: (c) => `Thank you for visiting Clean Hands Club${c.name ? ", " + c.name : ""}! We look forward to seeing you again: ${c.bookUrl}`,
    },
  },
  custom: {
    subject: { pl: "Clean Hands Club", uk: "Clean Hands Club", en: "Clean Hands Club" },
    body: { pl: () => "", uk: () => "", en: () => "" },
  },
};

// Побудувати {subject, body} для шаблону+мови з контексту запису.
export function buildMessage(key, lang, ctx = {}) {
  const tpl = T[key] || T.custom;
  const l = MESSAGE_LANGS.includes(lang) ? lang : "pl";
  const c = { ...ctx, findUsUrl, bookUrl };
  return {
    subject: tpl.subject[l],
    body: tpl.body[l](c),
  };
}
